module.exports = __webpack_public_path__ + "static/media/ncj_pend_0004.0720da3b.jpg";